import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import ItemModifierGroup from '../OrderItemModifiers/ItemModifierGroup';

/**
 * GlobalModifierPanel (V2)
 *
 * Renders the active global modifier group's items inline (no modal).
 * Uses the existing V2 ItemModifierGroup architecture.
 *
 * The modifier list is pre-filtered by search/alphabet in OrderItemHeader
 * via getGlobalModifierData → globalModifierLinksData in Redux.
 */
const GlobalModifierPanel = ({
  globalSelectedModifierId,
  globalModifierLinksData,
  modifierGroupsHashTable,
}) => {
  /**
   * Build a modifierGroup object for ItemModifierGroup.
   * Override modifierLinks with the search/alphabet-filtered list from Redux.
   */
  const modifierGroup = useMemo(() => {
    if (!globalSelectedModifierId) return null;
    const base = modifierGroupsHashTable[globalSelectedModifierId];
    if (!base) return null;

    // globalModifierLinksData[0].items contains the filtered modifier links
    const filteredLinks =
      globalModifierLinksData?.[0]?.items ?? base.modifierLinks ?? [];

    return {
      ...base,
      modifierLinks: filteredLinks,
      show: true,
    };
  }, [globalSelectedModifierId, modifierGroupsHashTable, globalModifierLinksData]);

  if (!modifierGroup) return null;

  return (
    <div
      className="rounded pb-1 pt-2 px-2 w-100 overflowY"
      id="globalModifiersContainer"
    >
      <ItemModifierGroup
        key={`global-${globalSelectedModifierId}`}
        modifierGroup={modifierGroup}
        isLoading={false}
      />
    </div>
  );
};

const mapStateToProps = ({ orders }) => ({
  globalSelectedModifierId: orders.globalSelectedModifierId,
  globalModifierLinksData: orders.globalModifierLinksData,
  modifierGroupsHashTable: orders.modifierGroupsHashTable,
});

export default connect(mapStateToProps)(React.memo(GlobalModifierPanel));
